/**
 * External URL builders for movie/TV databases and search engines.
 */

/** TMDB poster image URL (w300 size) */
export function tmdbPoster(path: string | undefined): string {
  return path ? `https://image.tmdb.org/t/p/w300${path}` : '';
}

/** TMDB provider logo URL (w92 size — small square) */
export function tmdbProviderLogo(path: string | undefined): string {
  return path ? `https://image.tmdb.org/t/p/w92${path}` : '';
}

/** IMDb title page (movies and TV shows) */
export function imdbTitleUrl(id: string | undefined): string {
  return id ? `https://www.imdb.com/title/${id}/` : '';
}

/** IMDb person page */
export function imdbPersonUrl(id: string | undefined): string {
  return id ? `https://www.imdb.com/name/${id}/` : '';
}

/** Rotten Tomatoes search URL */
export function rtSearchUrl(query: string | undefined): string {
  return query
    ? `https://www.rottentomatoes.com/search?search=${encodeURIComponent(query)}`
    : '';
}

/** Amazon product page by ASIN */
export function amazonUrl(asin: string | undefined): string {
  return asin ? `https://www.amazon.com/dp/${asin}` : '';
}

/** Open Library work page */
export function openLibraryUrl(key: string | undefined): string {
  return key ? `https://openlibrary.org${key}` : '';
}
